import { render, staticRenderFns } from "./detailes.vue?vue&type=template&id=db35cc28&scoped=true&"
import script from "./detailes.vue?vue&type=script&lang=js&"
export * from "./detailes.vue?vue&type=script&lang=js&"
import style0 from "./detailes.vue?vue&type=style&index=0&id=db35cc28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db35cc28",
  null
  
)

export default component.exports